import { render, staticRenderFns } from "./tip_popup.vue?vue&type=template&id=2a16d555"
import script from "./tip_popup.vue?vue&type=script&lang=js"
export * from "./tip_popup.vue?vue&type=script&lang=js"
import style0 from "./tip_popup.vue?vue&type=style&index=0&id=2a16d555&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports